import {environment} from "../../../../environments/environment";

function createUrl(actionName: string): string {
  return `${environment.apiBaseUrl}${environment.apiUrl}${environment.apiVersion}${actionName}`;
}

export const VendorApiResources = {
  list:  createUrl('vendors'),
  create:  createUrl('vendors/create'),
  detail:  createUrl('vendors'),
  getByName:  createUrl('vendors/getByName'),
  update:  createUrl('vendors'),
  delete:  createUrl('vendors'),
  deleteMultiple:  createUrl('vendors/delete/multiple'),
  deleteAvailability:  createUrl('vendors/delete/availability'),
  changeStatus: createUrl('/vendors/change/status'),
  copy: createUrl('vendors/copy'),
  // Sub Companies tab. All four hang off vendors/{id}/sub-companies, so the
  // base is stored once and the id is interpolated in the data service.
  subCompanies: createUrl('vendors'),
  // Import endpoints
  downloadSample: createUrl('vendors/import/sample'),
  uploadImport: createUrl('vendors/import/upload'),
  validateImport: createUrl('vendors/import/validate'),
  executeImport: createUrl('vendors/import/execute'),
  importHistory: createUrl('import-history'),
};
